import SiteLayout from "./SiteLayout";

const LegalPage = ({ eyebrow, title, intro, effectiveDate, sections, pageTestId }) => {
  return (
    <SiteLayout>
      <div className="page-shell legal-shell" data-testid={pageTestId}>
        <section className="legal-hero">
          <div className="eyebrow stagger-1" data-testid={`${pageTestId}-eyebrow`}>
            {eyebrow}
          </div>
          <h1 className="page-title stagger-2" data-testid={`${pageTestId}-title`}>
            {title}
          </h1>
          <p className="page-intro stagger-3" data-testid={`${pageTestId}-intro`}>
            {intro}
          </p>
          <div className="legal-meta stagger-4" data-testid={`${pageTestId}-effective-date`}>
            Effective Date — {effectiveDate}
          </div>
        </section>

        <section className="legal-grid" data-testid={`${pageTestId}-sections`}>
          {sections.map((section, index) => (
            <article className="section-card legal-card" data-testid={`${pageTestId}-section-${index + 1}`} key={section.title}>
              <h2 className="legal-card-title" data-testid={`${pageTestId}-section-title-${index + 1}`}>
                {section.title}
              </h2>
              {section.paragraphs?.map((paragraph, paragraphIndex) => (
                <p
                  className="legal-card-copy"
                  data-testid={`${pageTestId}-section-copy-${index + 1}-${paragraphIndex + 1}`}
                  key={`${section.title}-paragraph-${paragraphIndex}`}
                >
                  {paragraph}
                </p>
              ))}
              {section.items?.length ? (
                <ul className="legal-card-list" data-testid={`${pageTestId}-section-list-${index + 1}`}>
                  {section.items.map((item, itemIndex) => (
                    <li data-testid={`${pageTestId}-section-list-item-${index + 1}-${itemIndex + 1}`} key={`${section.title}-item-${itemIndex}`}>
                      {item}
                    </li>
                  ))}
                </ul>
              ) : null}
            </article>
          ))}
        </section>
      </div>
    </SiteLayout>
  );
};

export default LegalPage;